import { render } from "./MyDialogForm.vue?vue&type=template&id=1c00a425&scoped=true"
import script from "./MyDialogForm.vue?vue&type=script&lang=js"
export * from "./MyDialogForm.vue?vue&type=script&lang=js"

import exportComponent from "H:\\ideaProject\\vue\\fiveG-project\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c00a425"]])

export default __exports__